// import React, { useState, useCallback } from "react";
// import { 
//   FaUtensils, 
//   FaShieldAlt, 
//   FaStar, 
//   FaBook,
//   FaTimes
// } from "react-icons/fa";

// const VendorGuidelines = ({ isMobile }) => {
//     const [showDocumentViewer, setShowDocumentViewer] = useState(false);
//     const [currentDocument, setCurrentDocument] = useState({ 
//         title: '', 
//         content: '', 
//         type: '' 
//     });

//     const documentContents = {
//         vendorGuidelines: {
//             title: "Vendor Guidelines - FoodLeague Platform",
//             content: (
//                 <div style={{ textAlign: 'center', padding: '30px 20px' }}>
//                     <FaBook style={{ fontSize: '48px', color: '#A055B0', marginBottom: '15px' }} />
//                     <h3>Vendor Guidelines Content</h3>
//                     <p>This document content has been removed as per requirements.</p>
//                 </div>
//             )
//         }
//     };

//     const handleViewDocument = useCallback((type) => {
//         setCurrentDocument({
//             title: documentContents[type].title,
//             content: documentContents[type].content,
//             type: type
//         });
//         setShowDocumentViewer(true);
//     }, []);

//     const handleCloseDocumentViewer = useCallback(() => {
//         setShowDocumentViewer(false);
//     }, []);

//     const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
//         if (!isOpen) return null;
        
//         const isSmallScreen = window.innerWidth < 768;
        
//         return (
//             <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.8)',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 zIndex: 9999,
//                 padding: '20px'
//             }}>
//                 <div style={{
//                     backgroundColor: 'white',
//                     borderRadius: '8px',
//                     padding: isSmallScreen ? '15px' : '20px',
//                     maxWidth: isSmallScreen ? '95%' : '80%',
//                     width: '100%',
//                     maxHeight: isSmallScreen ? '80vh' : '85vh',
//                     display: 'flex',
//                     flexDirection: 'column'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         marginBottom: '15px',
//                         paddingBottom: '10px',
//                         borderBottom: '1px solid #e0e0e0'
//                     }}>
//                         <h3 style={{
//                             margin: 0,
//                             color: '#A055B0',
//                             fontSize: isSmallScreen ? '18px' : '20px',
//                             fontWeight: '500'
//                         }}>
//                             {title}
//                         </h3>
                        
//                         <button 
//                             onClick={onClose}
//                             aria-label="Close document viewer"
//                             style={{
//                                 backgroundColor: '#f44336',
//                                 color: 'white',
//                                 border: 'none',
//                                 padding: '8px 16px',
//                                 borderRadius: '4px',
//                                 cursor: 'pointer',
//                                 fontSize: '14px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px'
//                             }}
//                         >
//                             <FaTimes /> Close
//                         </button>
//                     </div>
                    
//                     <div style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                         padding: '15px'
//                     }}>
//                         <div style={{ textAlign: 'center' }}>
//                             <FaBook style={{ fontSize: '36px', color: '#A055B0', marginBottom: '10px' }} />
//                             <h4>Document Content Removed</h4>
//                             <p>This document content has been removed as per requirements.</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <>
//             <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "8px",
//                 padding: isMobile ? "5px" : "25px",
//                 //border: "1px solid #e0e0e0",
//                 minHeight: "400px"
//             }}>
//                 <div style={{ marginTop: '20px' }}>
//                     <h5 style={{ 
//                         fontSize: isMobile ? '18px' : '22px', 
//                         color: '#2e7d32',
//                         textAlign: 'center',
//                         marginBottom: '20px',
//                         paddingBottom: '15px',
//                         borderBottom: '2px solid #2e7d32'
//                     }}>
//                         <FaUtensils style={{ marginRight: '15px' }} />
//                         Food & Beverages Vendor Excellence Standards
//                     </h5>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#e65100',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             🍳 Food Safety & Hygiene Standards
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#d84315',
//                                 marginBottom: '15px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 <FaShieldAlt style={{ marginRight: '10px' }} />
//                                 HACCP Compliance Requirements
//                             </h6>
//                             <ul style={{ paddingLeft: '20px', marginBottom: '15px', fontSize: '14px' }}>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Temperature Control:</strong> All refrigeration units must maintain temperatures below 5°C (41°F). Freezers must be at -18°C (0°F) or lower. Temperature logs must be maintained every 4 hours.
//                                 </li>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Food Storage:</strong> Raw and cooked foods must be stored separately. All food items must be labeled with preparation date and use-by date.
//                                 </li>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Cross-Contamination Prevention:</strong> Color-coded cutting boards and utensils for different food types. Separate preparation areas for allergen-free meals.
//                                 </li>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Cooking Temperatures:</strong> Poultry: 74°C (165°F), Ground meats: 71°C (160°F), Pork: 63°C (145°F), Seafood: 63°C (145°F).
//                                 </li>
//                             </ul>
//                         </div>

//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#d84315',
//                                 marginBottom: '15px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 👨‍🍳 Staff Hygiene & Training
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#e65100' }}>Personal Hygiene</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                         <li>Hand washing every 30 minutes</li>
//                                         <li>Clean uniforms daily</li>
//                                         <li>Hair restraints mandatory</li>
//                                         <li>No jewelry in food areas</li>
//                                     </ul>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#e65100' }}>Health Requirements</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                         <li>Annual medical examinations</li>
//                                         <li>No working with infectious diseases</li>
//                                         <li>Regular health declaration</li>
//                                         <li>Vaccination records maintained</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#2e7d32',
//                             marginBottom: '20px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             🥘 Quality & Consistency Standards
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#388e3c',
//                                 marginBottom: '10px'
//                             }}>
//                                 Ingredient Quality Control
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '10px'
//                             }}>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>100%</div>
//                                     <div style={{ fontSize: '12px', color: '#666' }}>Fresh Ingredients Only</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>24h</div>
//                                     <div style={{ fontSize: '12px', color: '#666' }}>Delivery-to-Use Window</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>5⭐</div>
//                                     <div style={{ fontSize: '12px', color: '#666' }}>Supplier Rating Minimum</div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ 
//                                 padding: '15px', 
//                                 borderRadius: '6px',
//                                 fontSize: '14px',
//                                 backgroundColor: '#fff'
//                             }}>
//                                 <strong>Ingredient Specifications:</strong>
//                                 <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
//                                     <li>Vegetables: Washed and sanitized within 2 hours of receipt</li>
//                                     <li>Meat & Poultry: From approved suppliers with traceability certificates</li>
//                                     <li>Seafood: Fresh only, delivered daily with temperature certification</li>
//                                     <li>Spices & Herbs: Organic preferred, stored in airtight containers</li>
//                                 </ul>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#388e3c',
//                                 marginBottom: '15px'
//                             }}>
//                                 Portion Control & Presentation
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#388e3c' }}>Standardized Portions</strong>
//                                     <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
//                                         All dishes must follow standardized portion sizes (±5% variance). Regular calibration of measuring equipment required.
//                                     </p>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#388e3c' }}>Presentation Standards</strong>
//                                     <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
//                                         Consistent plating, garnish placement, and service ware. Daily quality control checks with photo documentation.
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#1565c0',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             ⏱️ Service & Operational Excellence
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '10px'
//                             }}>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>15</div>
//                                     <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Order Acknowledgment</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>30</div>
//                                     <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Preparation Time Max</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>99%</div>
//                                     <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Order Accuracy Required</div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ 
//                                 padding: '15px', 
//                                 borderRadius: '6px',
//                                 fontSize: '14px',
//                                 backgroundColor: '#fff'
//                             }}>
//                                 <strong>Customer Service Protocol:</strong>
//                                 <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
//                                     <li>Phone answered within 3 rings during business hours</li>
//                                     <li>Email responses within 2 hours during business hours</li>
//                                     <li>Online order confirmation within 10 minutes</li>
//                                     <li>Special requests acknowledged and documented</li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#7b1fa2',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             📋 Compliance & Documentation
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#7b1fa2' }}>Required Licenses</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '5px', fontSize: '13px' }}>
//                                         <li>FSSAI License (Valid)</li>
//                                         <li>Health Trade License</li>
//                                         <li>Fire Safety Certificate</li>
//                                         <li>GST Registration</li>
//                                         <li>Shop & Establishment Act</li>
//                                     </ul>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#7b1fa2' }}>Mandatory Documentation</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                         <li>Daily Temperature Logs</li>
//                                         <li>Staff Training Records</li>
//                                         <li>Supplier Certificates</li>
//                                         <li>Pest Control Reports</li>
//                                         <li>Equipment Maintenance Logs</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginTop: '10px',
//                         textAlign: 'center',
//                        // border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '22px',
//                             color: '#ff6f00',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center'
//                         }}>
//                             <FaStar style={{ marginRight: '15px' }} />
//                             Performance Metrics & Reviews
//                         </h6>
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//                             gap: '15px',
//                             marginBottom: '15px'
//                         }}>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>4.5⭐</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Minimum Customer Rating</div>
//                             </div>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>95%</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Order Accuracy Required</div>
//                             </div>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>30min</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Max Preparation Time</div>
//                             </div>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>48h</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Complaint Resolution Time</div>
//                             </div>
//                         </div>
                        
//                         <div style={{ 
//                             marginTop: '15px', 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             textAlign: 'center',
//                             backgroundColor: '#fff3e0'
//                         }}>
//                             <p style={{ margin: 0, fontSize: isMobile ? '14px' : '16px', fontWeight: 'bold', color: '#d84315' }}>
//                                 ⚠️ Compliance Note: Vendors maintaining below 4.0 rating for 3 consecutive months will undergo mandatory retraining. 
//                                 Ratings below 3.5 for 2 months may result in temporary suspension.
//                             </p>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginTop: '15px',
//                         textAlign: 'center',
//                         backgroundColor: '#f9f9f9'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#2e7d32',
//                             marginBottom: '10px'
//                         }}>
//                             🎯 Continuous Improvement Program
//                         </h6>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#333', marginBottom: '10px' }}>
//                             Monthly performance reviews with improvement action plans. Quarterly mystery shopping evaluations. 
//                             Annual comprehensive audit with certification renewal.
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             <DocumentViewerModal 
//                 isOpen={showDocumentViewer}
//                 onClose={handleCloseDocumentViewer}
//                 title={currentDocument.title}
//                 content={currentDocument.content}
//             />
//         </>
//     );
// };

// export default VendorGuidelines;



















import React, { useState, useCallback } from "react";
import { 
  FaUserShield, 
  FaShieldAlt, 
  FaChartLine, 
  FaDatabase,
  FaBook,
  FaTimes,
  FaGavel,
  FaLock,
  FaEye,
  FaKey,
  FaServer,
  FaNetworkWired,
  FaCogs,
  FaUsersCog,
  FaFileContract,
  FaExclamationTriangle
} from "react-icons/fa";

const SuperAdminGuidelines = ({ isMobile }) => {
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [currentDocument, setCurrentDocument] = useState({ 
        title: '', 
        content: '', 
        type: '' 
    });

    const documentContents = {
        adminGuidelines: {
            title: "SuperAdmin Platform Governance Guidelines",
            content: (
                <div style={{ textAlign: 'center', padding: '30px 20px' }}>
                    <FaBook style={{ fontSize: '48px', color: '#1a237e', marginBottom: '15px' }} />
                    <h3>SuperAdmin Governance Guidelines</h3>
                    <p>This document contains sensitive administrative procedures and security protocols.</p>
                </div>
            )
        }
    };

    const handleViewDocument = useCallback((type) => {
        setCurrentDocument({
            title: documentContents[type].title,
            content: documentContents[type].content,
            type: type
        });
        setShowDocumentViewer(true);
    }, []);

    const handleCloseDocumentViewer = useCallback(() => {
        setShowDocumentViewer(false);
    }, []);

    const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
        if (!isOpen) return null;
        
        const isSmallScreen = window.innerWidth < 768;
        
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                padding: '20px'
            }}>
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: isSmallScreen ? '15px' : '25px',
                    maxWidth: isSmallScreen ? '95%' : '75%',
                    width: '100%',
                    maxHeight: isSmallScreen ? '80vh' : '85vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
                    border: '2px solid #1a237e'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '20px',
                        paddingBottom: '15px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        <h3 style={{
                            margin: 0,
                            color: '#1a237e',
                            fontSize: isSmallScreen ? '18px' : '22px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <FaUserShield />
                            {title}
                        </h3>
                        
                        <button 
                            onClick={onClose}
                            aria-label="Close document viewer"
                            style={{
                                backgroundColor: '#d32f2f',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#b71c1c';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#d32f2f';
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                        >
                            <FaTimes /> Secure Close
                        </button>
                    </div>
                    
                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '20px',
                        backgroundColor: '#f5f7ff',
                        borderRadius: '8px'
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <FaBook style={{ fontSize: '48px', color: '#1a237e', marginBottom: '15px' }} />
                            <h4 style={{ color: '#1a237e', marginBottom: '10px' }}>Restricted Administrative Content</h4>
                            <p style={{ color: '#666', marginBottom: '20px' }}>
                                This document contains sensitive platform administration guidelines, security protocols, 
                                and compliance procedures. Access is logged and monitored.
                            </p>
                            <div style={{
                                backgroundColor: '#e8eaf6',
                                padding: '15px',
                                borderRadius: '6px',
                                marginTop: '20px'
                            }}>
                                <p style={{ margin: 0, fontSize: '14px', color: '#333' }}>
                                    <strong>Access Logged:</strong> {new Date().toLocaleString()}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: isMobile ? "15px" : "30px",
                border: "1px solid #e0e0e0",
                minHeight: "400px",
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
            }}>
                <div style={{ marginTop: '10px' }}>
                    <div style={{ 
                        textAlign: 'center', 
                        marginBottom: '30px',
                        paddingBottom: '20px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '15px',
                            backgroundColor: '#f5f7ff',
                            padding: '15px 30px',
                            borderRadius: '50px',
                            marginBottom: '15px'
                        }}>
                            <FaUserShield style={{ 
                                fontSize: isMobile ? '28px' : '36px',
                                color: '#1a237e' 
                            }} />
                            <h5 style={{ 
                                fontSize: isMobile ? '20px' : '28px', 
                                color: '#1a237e',
                                margin: 0,
                                fontWeight: 'bold'
                            }}>
                                Platform Governance Guidelines
                            </h5>
                        </div>
                        <p style={{
                            color: '#666',
                            fontSize: isMobile ? '14px' : '16px',
                            maxWidth: '800px',
                            margin: '0 auto'
                        }}>
                            Administrative Protocols, Security Standards & Compliance Framework
                        </p>
                    </div>

                    {/* Section 1: Security & Access Control */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginBottom: '25px',
                        backgroundColor: '#f5f7ff',
                        border: '1px solid #d1d9ff'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#1a237e',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <FaLock style={{ flexShrink: 0 }} />
                            Security & Access Control Protocols
                        </h6>
                        
                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            marginBottom: '20px',
                            backgroundColor: '#ffffff',
                            borderLeft: '4px solid #1a237e'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#283593',
                                marginBottom: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <FaKey />
                                Authentication & Authorization Standards
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                                gap: '15px',
                                marginBottom: '20px'
                            }}>
                                <div style={{ 
                                    padding: '20px', 
                                    borderRadius: '8px', 
                                    backgroundColor: '#f8f9fa',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: '10px',
                                        marginBottom: '10px'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            backgroundColor: '#1a237e',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontWeight: 'bold'
                                        }}>
                                            MFA
                                        </div>
                                        <strong style={{ color: '#1a237e' }}>Multi-Factor Authentication</strong>
                                    </div>
                                    <p style={{ fontSize: '13px', color: '#555', margin: 0 }}>
                                        Mandatory for all admin sessions. Hardware tokens required for Tier-1 access.
                                    </p>
                                </div>
                                <div style={{ 
                                    padding: '20px', 
                                    borderRadius: '8px', 
                                    backgroundColor: '#f8f9fa',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: '10px',
                                        marginBottom: '10px'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            backgroundColor: '#283593',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontWeight: 'bold'
                                        }}>
                                            RBAC
                                        </div>
                                        <strong style={{ color: '#283593' }}>Role-Based Access</strong>
                                    </div>
                                    <p style={{ fontSize: '13px', color: '#555', margin: 0 }}>
                                        Strict adherence to Principle of Least Privilege. Quarterly access reviews.
                                    </p>
                                </div>
                                <div style={{ 
                                    padding: '20px', 
                                    borderRadius: '8px', 
                                    backgroundColor: '#f8f9fa',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: '10px',
                                        marginBottom: '10px'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            backgroundColor: '#303f9f',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontWeight: 'bold'
                                        }}>
                                            IPW
                                        </div>
                                        <strong style={{ color: '#303f9f' }}>IP Whitelisting</strong>
                                    </div>
                                    <p style={{ fontSize: '13px', color: '#555', margin: 0 }}>
                                        Production access only from approved IP ranges. Real-time monitoring.
                                    </p>
                                </div>
                            </div>
                            
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: '#e8eaf6',
                                borderLeft: '3px solid #d32f2f'
                            }}>
                                <strong style={{ color: '#d32f2f' }}>SECURITY VIOLATION PROTOCOL:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px', color: '#666' }}>
                                    <li>Immediate session termination on violation detection</li>
                                    <li>Automatic SOC alert generation</li>
                                    <li>Mandatory security review for reinstatement</li>
                                    <li>Quarterly penetration testing required</li>
                                </ul>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            backgroundColor: '#ffffff',
                            borderLeft: '4px solid #283593'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#283593',
                                marginBottom: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <FaEye />
                                Monitoring & Audit Requirements
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                gap: '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#f8f9fa' }}>
                                    <strong style={{ color: '#283593' }}>Real-Time Monitoring</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>24/7 Security Operations Center</li>
                                        <li>Anomaly detection algorithms</li>
                                        <li>Automated alert escalation</li>
                                        <li>SIEM integration mandatory</li>
                                    </ul>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#f8f9fa' }}>
                                    <strong style={{ color: '#283593' }}>Audit Trail Standards</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>Immutable log storage (10 years)</li>
                                        <li>Blockchain verification for critical actions</li>
                                        <li>Monthly log integrity checks</li>
                                        <li>Regulatory audit support</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 2: Platform Governance */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginBottom: '25px',
                        backgroundColor: '#e8f5e9',
                        border: '1px solid #c8e6c9'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#2e7d32',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <FaServer style={{ flexShrink: 0 }} />
                            Platform Governance Framework
                        </h6>
                        
                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            marginBottom: '20px',
                            backgroundColor: '#ffffff'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#388e3c',
                                marginBottom: '10px'
                            }}>
                                Change Management Protocol
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
                                gap: '15px',
                                marginBottom: '20px'
                            }}>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f1f8e9' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>Tier-1</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Dual Authorization Required</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f1f8e9' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>72h</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Change Notice Period</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f1f8e9' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>100%</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Rollback Test Coverage</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f1f8e9' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>SRE</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Site Reliability Review</div>
                                </div>
                            </div>
                            
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: '#f1f8e9'
                            }}>
                                <strong>Change Implementation Checklist:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                    <li>Security impact assessment completed</li>
                                    <li>Backup verified before implementation</li>
                                    <li>Rollback procedure documented and tested</li>
                                    <li>Stakeholder communication plan executed</li>
                                    <li>Post-implementation review scheduled</li>
                                </ul>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            backgroundColor: '#ffffff'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#388e3c',
                                marginBottom: '15px'
                            }}>
                                Vendor Management Standards
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                gap: '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#f1f8e9' }}>
                                    <strong style={{ color: '#388e3c' }}>Vendor Onboarding</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>Comprehensive due diligence</li>
                                        <li>Security assessment completed</li>
                                        <li>Contractual SLA agreement</li>
                                        <li>Integration testing required</li>
                                        <li>Compliance certification verified</li>
                                    </ul>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#f1f8e9' }}>
                                    <strong style={{ color: '#388e3c' }}>Performance Monitoring</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>Monthly performance reviews</li>
                                        <li>Quarterly security audits</li>
                                        <li>SLA compliance tracking</li>
                                        <li>Annual risk re-assessment</li>
                                        <li>Continuous improvement plans</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Compliance & Regulatory */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginBottom: '25px',
                        backgroundColor: '#e3f2fd',
                        border: '1px solid #bbdefb'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#1565c0',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <FaGavel style={{ flexShrink: 0 }} />
                            Compliance & Regulatory Framework
                        </h6>
                        
                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            marginBottom: '15px',
                            backgroundColor: '#ffffff'
                        }}>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                gap: '15px',
                                marginBottom: '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#e3f2fd' }}>
                                    <strong style={{ color: '#1565c0' }}>Data Protection Regulations</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>GDPR Compliance (Articles 5-32)</li>
                                        <li>Indian DPDP Act, 2023</li>
                                        <li>CCPA/CPRA Requirements</li>
                                        <li>Data Localization Laws</li>
                                        <li>Cross-Border Transfer Rules</li>
                                    </ul>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#e3f2fd' }}>
                                    <strong style={{ color: '#1565c0' }}>Industry Standards</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>PCI-DSS Level 1 Certification</li>
                                        <li>ISO 27001:2022</li>
                                        <li>SOC 2 Type II</li>
                                        <li>NIST Cybersecurity Framework</li>
                                        <li>FSSAI Regulations (Food Sector)</li>
                                    </ul>
                                </div>
                            </div>
                            
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: '#bbdefb',
                                borderLeft: '3px solid #1565c0'
                            }}>
                                <strong>Compliance Reporting Requirements:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                    <li>Quarterly compliance status reports to Board</li>
                                    <li>Annual external audit by certified firm</li>
                                    <li>Monthly regulatory change impact assessment</li>
                                    <li>Bi-annual compliance training for all admins</li>
                                    <li>Real-time compliance dashboard monitoring</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Section 4: Incident Response */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginBottom: '25px',
                        backgroundColor: '#ffebee',
                        border: '1px solid #ffcdd2'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#c62828',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <FaExclamationTriangle style={{ flexShrink: 0 }} />
                            Incident Response & Breach Management
                        </h6>
                        
                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            backgroundColor: '#ffffff'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#d32f2f',
                                marginBottom: '15px'
                            }}>
                                Response Timeline Requirements
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
                                gap: '15px',
                                marginBottom: '20px'
                            }}>
                                <div style={{ textAlign: 'center', padding: '20px', borderRadius: '6px', backgroundColor: '#ffebee' }}>
                                    <div style={{ fontSize: '28px', color: '#d32f2f', fontWeight: 'bold', marginBottom: '10px' }}>15min</div>
                                    <div style={{ fontSize: '13px', color: '#c62828' }}>Initial Assessment</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '20px', borderRadius: '6px', backgroundColor: '#ffebee' }}>
                                    <div style={{ fontSize: '28px', color: '#d32f2f', fontWeight: 'bold', marginBottom: '10px' }}>1h</div>
                                    <div style={{ fontSize: '13px', color: '#c62828' }}>Containment Activation</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '20px', borderRadius: '6px', backgroundColor: '#ffebee' }}>
                                    <div style={{ fontSize: '28px', color: '#d32f2f', fontWeight: 'bold', marginBottom: '10px' }}>24h</div>
                                    <div style={{ fontSize: '13px', color: '#c62828' }}>Regulatory Notification</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '20px', borderRadius: '6px', backgroundColor: '#ffebee' }}>
                                    <div style={{ fontSize: '28px', color: '#d32f2f', fontWeight: 'bold', marginBottom: '10px' }}>72h</div>
                                    <div style={{ fontSize: '13px', color: '#c62828' }}>Public Disclosure</div>
                                </div>
                            </div>
                            
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: '#ffcdd2'
                            }}>
                                <strong>CRITICAL INCIDENT PROTOCOL:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px', color: '#b71c1c' }}>
                                    <li>Immediate activation of Incident Response Team</li>
                                    <li>Preservation of all digital evidence</li>
                                    <li>Legal counsel notification within 30 minutes</li>
                                    <li>Forensic investigation commencement</li>
                                    <li>Board-level notification for major incidents</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Section 5: Performance Metrics */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginBottom: '20px',
                        backgroundColor: '#f3e5f5',
                        border: '1px solid #e1bee7',
                        textAlign: 'center'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#7b1fa2',
                            marginBottom: '25px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '15px'
                        }}>
                            <FaChartLine style={{ flexShrink: 0 }} />
                            Administrative Performance Metrics
                        </h6>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
                            gap: '15px',
                            marginBottom: '25px'
                        }}>
                            <div style={{ textAlign: 'center', padding: '20px', borderRadius: '8px', backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                <div style={{ fontSize: '32px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>99.9%</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Platform Uptime SLA</div>
                                <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>Monthly Target</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '20px', borderRadius: '8px', backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                <div style={{ fontSize: '32px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>≤15min</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Critical Incident Response</div>
                                <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>Average Time</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '20px', borderRadius: '8px', backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                <div style={{ fontSize: '32px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>100%</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Security Patch Compliance</div>
                                <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>Within 72 hours</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '20px', borderRadius: '8px', backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                <div style={{ fontSize: '32px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>24/7</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>SOC Monitoring Coverage</div>
                                <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>Security Operations</div>
                            </div>
                        </div>
                        
                        <div style={{ 
                            padding: '20px', 
                            borderRadius: '8px',
                            textAlign: 'center',
                            backgroundColor: '#ffffff',
                            border: '2px solid #7b1fa2'
                        }}>
                            <p style={{ margin: 0, fontSize: isMobile ? '14px' : '16px', fontWeight: 'bold', color: '#7b1fa2' }}>
                                ⚠️ ADMINISTRATIVE PERFORMANCE NOTE: SuperAdmins failing to meet 3 consecutive quarterly targets 
                                will undergo mandatory retraining and access review. Critical metric failures may result in 
                                temporary privilege suspension.
                            </p>
                        </div>
                    </div>

                    {/* Section 6: Documentation & Training */}
                    <div style={{ 
                        padding: '20px', 
                        borderRadius: '10px',
                        marginTop: '15px',
                        textAlign: 'center',
                        backgroundColor: '#fff3e0',
                        border: '1px solid #ffe0b2'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '20px',
                            color: '#ef6c00',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px'
                        }}>
                            <FaFileContract />
                            Documentation & Continuous Training
                        </h6>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                            gap: '15px',
                            marginBottom: '20px'
                        }}>
                            <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#ffffff' }}>
                                <strong style={{ color: '#ef6c00' }}>Required Documentation</strong>
                                <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px', textAlign: 'left' }}>
                                    <li>Quarterly Risk Assessment Reports</li>
                                    <li>Monthly Security Audit Findings</li>
                                    <li>Incident Response Documentation</li>
                                    <li>Change Management Logs</li>
                                    <li>Compliance Certification Records</li>
                                </ul>
                            </div>
                            <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#ffffff' }}>
                                <strong style={{ color: '#ef6c00' }}>Training Requirements</strong>
                                <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px', textAlign: 'left' }}>
                                    <li>Annual Security Certification</li>
                                    <li>Quarterly Compliance Updates</li>
                                    <li>Bi-annual Disaster Recovery Drills</li>
                                    <li>Monthly Threat Intelligence Briefings</li>
                                    <li>New Regulation Training (as needed)</li>
                                </ul>
                            </div>
                        </div>
                        
                        <button 
                            onClick={() => handleViewDocument('adminGuidelines')}
                            style={{
                                backgroundColor: '#1a237e',
                                color: 'white',
                                border: 'none',
                                padding: '15px 30px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '12px',
                                transition: 'all 0.3s ease',
                                marginTop: '10px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#283593';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(26, 35, 126, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#1a237e';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <FaBook />
                            View Complete Governance Guidelines
                        </button>
                        <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                            Contains detailed administrative procedures, security protocols, and compliance requirements
                        </p>
                    </div>
                </div>
            </div>

            <DocumentViewerModal 
                isOpen={showDocumentViewer}
                onClose={handleCloseDocumentViewer}
                title={currentDocument.title}
                content={currentDocument.content}
            />
        </>
    );
};

export default SuperAdminGuidelines;